import { Hammer } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { findSubNav } from '../settings-tree'
import './ComingSoonPage.scss'

interface ComingSoonPageProps {
  /** TopNav id this stub lives under — used to resolve the subNav label. */
  topNavId: string
  /** SubNav id this stub stands in for. */
  subNavId: string
}

/**
 * Generic placeholder rendered for every SubPage that hasn't been built
 * yet. Shows the SubNav's own label so the user knows where they are,
 * plus a friendly "we're working on it" line.
 */
export function ComingSoonPage({ topNavId, subNavId }: ComingSoonPageProps) {
  const { t } = useTranslation()
  const entry = findSubNav(topNavId, subNavId)
  const label = entry ? t(entry.i18nKey) : ''

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-page__icon">
        <Hammer size={28} strokeWidth={1.6} aria-hidden="true" />
      </div>
      <h2 className="coming-soon-page__title">{label}</h2>
      <p className="coming-soon-page__hint">{t('settings.comingSoon.title')}</p>
      <p className="coming-soon-page__description">{t('settings.comingSoon.description')}</p>
    </div>
  )
}
